(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector/assets/javascripts/draw-closed.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector/assets/javascripts/draw-closed.js');
"use strict";

const {
  ReactIcon
} = svs.ui;
const {
  urlMapping
} = svs.core;
const {
  useIsDrawRegBetDisabled
} = svs.components.tipsen.hooks;
const DrawClosed = _ref => {
  let {
    productId,
    drawNumber,
    isCollapsed
  } = _ref;
  const isRegBetDisabled = useIsDrawRegBetDisabled(productId, drawNumber);
  if (isRegBetDisabled) {
    return null;
  }
  const classNames = ['draw-item-draw-closed'];
  if (isCollapsed) {
    classNames.push('draw-item-draw-closed-is-collapsed');
  }
  const className = classNames.join(' ');
  return React.createElement("div", {
    className: className
  }, React.createElement(ReactIcon, {
    className: "margin-1",
    icon: "rest",
    size: "600"
  }), React.createElement("p", {
    className: "draw-item-draw-closed-message"
  }, "Omg\xE5ngen \xE4r tillf\xE4lligt st\xE4ngd."), React.createElement("p", {
    className: "draw-item-draw-closed-message"
  }, "V\xE4lkommen \xE5ter."), React.createElement("p", null, React.createElement("a", {
    href: urlMapping.get('cancelledDrawsInfo')
  }, "Mer information h\xE4r")));
};
setGlobal('svs.components.tipsen.drawselector.DrawClosed', DrawClosed);

 })(window);